import "./Header.css";

function Header() {
  return (
    <div className="header">
      <img
        className="globe-img"
        src="./globe-showing-americas.png"
        alt="globe showing americas"
      />
      <h1>Worldle</h1>
    </div>
  );
}

export default Header;
